const locale = {
    // Existing translations
    AWAITING_MAINTENANCE: 'Awaiting maintenance',
    BEGIN_MAINTENANCE: 'Begin maintenance',
    ROOM_NUMBER: 'Room number',
    
    // Notification translations
    MAINTENANCE_PROBLEM_TITLE: 'New Maintenance Request',
    MAINTENANCE_PROBLEM_BODY: 'Room {{room}}: {{problem}} (Priority: {{priority}})',

    // Tech Support Dashboard translations
    TECH_SUPPORT_DASHBOARD: 'Tech Support Dashboard',
    
    // Stats Cards
    TOTAL_REQUESTS: 'Total Requests',
    PENDING: 'Pending',
    IN_PROGRESS: 'In Progress',
    COMPLETED: 'Completed',
    COMPLETED_SINGLE: 'Completed',
    LAST_24H: 'Last 24h',
    LAST_7_DAYS: 'Last 7 Days',
    
    // Filters
    SEARCH: 'Search',
    STATUS: 'Status',
    ALL_STATUSES: 'All Statuses',
    
    // Table Headers
    ROOM: 'Room',
    ITEM: 'Item',
    DESCRIPTION: 'Description',
    START_TIME: 'Start Time',
    END_TIME: 'End Time',
    DURATION: 'Duration',
    ACTIONS: 'Actions',
    
    // Action Buttons
    VIEW: 'View',
    START: 'Start',
    FINISH: 'Finish',
    REFRESH: 'Refresh',
    
    // Dialog
    MAINTENANCE_REQUEST_DETAILS: 'Maintenance Request Details',
    REQUEST_INFORMATION: 'Request Information',
    TIMELINE: 'Timeline',
    CLOSE: 'Close',
    START_REQUEST: 'Start Request',
    FINISH_REQUEST: 'Finish Request',
    
    // Request Info Labels
    FLOOR: 'Floor',
    CATEGORY: 'Category',
    LAST_UPDATED: 'Last Updated',
    ASSIGNED_TO: 'Assigned to',
    REPORTED_BY: 'Reported by',
    STARTED: 'Started',
    NOT_STARTED: 'Not Started',
    NO_DURATION: 'No Duration',
    
    // Status Values
    REPORTED: 'Reported',
    ASSIGNED: 'Assigned',
    AWAITING_FIXING: 'Awaiting Fixing',
    CANCELLED: 'Cancelled',
    
    // Error Messages
    FAILED_TO_FETCH_REQUESTS: 'Failed to fetch maintenance requests',
    FAILED_TO_START_REQUEST: 'Failed to start maintenance request',
    FAILED_TO_FINISH_REQUEST: 'Failed to finish maintenance request',
    
    // Success Messages
    REQUEST_STARTED_SUCCESSFULLY: 'Maintenance request started successfully',
    REQUEST_COMPLETED_SUCCESSFULLY: 'Maintenance request completed successfully',
    
    // Create Request Form
    CREATE_MAINTENANCE_REQUEST: 'Create Maintenance Request',
    SELECT_ROOM: 'Select Room',
    SELECT_ROOM_HELP: 'Choose the room where the maintenance issue is located',
    SELECT_ITEM: 'Select Item',
    SELECT_ITEM_HELP: 'Choose the item that needs maintenance',
    PRIORITY: 'Priority',
    PRIORITY_LOW: 'Low',
    PRIORITY_MEDIUM: 'Medium',
    PRIORITY_HIGH: 'High',
    PRIORITY_CRITICAL: 'Critical',
    DESCRIPTION_HELP: 'Please provide detailed description of the maintenance issue',
    DESCRIPTION_PLACEHOLDER: 'Describe the problem in detail...',
    ITEM_INFORMATION: 'Item Information',
    REQUIRED_FIELDS_MESSAGE: 'Please fill in all required fields',
    CREATE_REQUEST: 'Create Request',
    CREATING: 'Creating...',
    CANCEL: 'Cancel',
    
    // Categories
    CATEGORY_FURNITURE: 'Furniture',
    CATEGORY_ELECTRONICS: 'Electronics',
    CATEGORY_BATHROOM: 'Bathroom',
    CATEGORY_LIGHTING: 'Lighting',
    CATEGORY_OTHER: 'Other',
    

    
    // Loading States
    LOADING: 'Loading...',
    SUBMITTING: 'Submitting...',
    
    // Empty States
    NO_REQUESTS_FOUND: 'No maintenance requests found',
    NO_DATA_AVAILABLE: 'No data available',
    
    // Additional error messages for form
    FAILED_TO_CREATE_REQUEST: 'Failed to create maintenance request. Please try again.',
    FAILED_TO_LOAD_ROOMS: 'Failed to load rooms',
    FAILED_TO_LOAD_ITEMS: 'Failed to load maintenance items'
};

export default locale;
